<template>
  <div class="modal-container">
    <div class="modal-content" :style="{ width: width }">
      <div class="header">
        <div class="title">
          {{ title }}
        </div>
        <img
          :class="['close-icon', loadingPrimaryButton && 'disabled']"
          src="https://dp3k82tjmkfj0.cloudfront.net/assets/close.svg"
          @click="closeModal"
        />
      </div>

      <div class="modal-body">
        <slot></slot>
      </div>
      <div v-show="primaryCtaText || secondaryCtaText" class="footer">
        <slot name="footer-content" />
        <GoldcastButton
          v-show="secondaryCtaText"
          v-if="secondaryCtaText"
          :backgroundColor="secondaryButtonColor"
          class="secondary-button"
          :disable="disableSecondaryButton || loadingSecondaryButton"
          :loading="loadingSecondaryButton"
          textColor="#000"
          @onClick="$emit('secondary-button-click')"
        >
          {{ secondaryCtaText }}
        </GoldcastButton>
        <GoldcastButton
          v-show="primaryCtaText"
          id="primary-button-id"
          :backgroundColor="primaryButtonColor"
          :loading="loadingPrimaryButton"
          :disable="loadingPrimaryButton || disablePrimaryButton"
          @onClick="$emit('primary-button-click')"
          >{{ primaryCtaText }}
        </GoldcastButton>
      </div>
    </div>
  </div>
</template>

<script>
import GoldcastButton from './GoldcastButton.vue';

export default {
  name: 'Modal',
  components: { GoldcastButton },
  props: {
    width: { type: String, required: true },
    title: { type: String, required: true },
    loadingPrimaryButton: { type: Boolean, default: false },
    loadingSecondaryButton: { type: Boolean, default: false },
    primaryCtaText: { type: String, default: '' },
    secondaryCtaText: { type: String, default: '' },
    primaryButtonColor: { type: String, default: '#4285F4' },
    secondaryButtonColor: { type: String, default: 'white' },
    disablePrimaryButton: { type: Boolean, default: false },
    disableSecondaryButton: { type: Boolean, default: false }
  },
  mounted() {
    this.$root.$el.append(this.$el);
    this.setPrimaryButtonMinWidth();
  },
  unmounted() {
    this.$el?.parentNode?.removeChild(this.$el);
  },
  methods: {
    closeModal() {
      this.$emit('onClose');
    },
    setPrimaryButtonMinWidth() {
      const primaryButton = document.getElementById('primary-button-id');
      primaryButton.style.minWidth = `${primaryButton.clientWidth}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .modal-content {
    max-height: 90%;
    overflow-y: auto;
    border-radius: 8px;
    margin: auto;
    border: 1px solid #888;
    background: white;

    .header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      border-bottom: 1px solid #d8d8df;

      .close-icon {
        cursor: pointer;
      }

      .close-icon.disabled {
        cursor: not-allowed;
      }

      .title {
        flex-basis: 100%;
        padding: 16px;
        font-size: 16px !important;
        line-height: 20px;
        font-weight: 500;
      }
    }

    .modal-body {
      overflow-y: auto;
      padding: 16px;
    }

    .footer {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      display: flex;
      justify-content: flex-end;
      align-content: center;
      padding: 18px;
      border-top: 1px solid #d8d8df;

      .secondary-button {
        border: 1px solid #d8d8df;
        margin-right: 8px;
      }
    }
  }
}
</style>
